module.exports = __webpack_public_path__ + "img/loading.7971860c.svg";